import { CustomTextFieldNumberComponente, SampleCheckbox, TabTextLabel } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { ConfiguracionTransitoInterface } from "../types/configuracion-transito.interface";
import { useCreateConfiguracionTransito } from "../actions/configuracion-inventario.actions";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { gridSizeMdLg6 } from "@/shared";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import { getBodegas, getUbicaciones } from "@/shared/actions/erp";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";

type SaveFormData = Omit<ConfiguracionTransitoInterface, 'id'>;

export default function ModalKardexSeries({ open, onClose, fetchData }: { open: boolean, onClose: () => void, fetchData: () => void }) {

    const queryClient = useQueryClient();
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    // hook para registrar orden de trabajo noc
    const useCreateConfiguracionTransitoMutation = useCreateConfiguracionTransito();

    const newConfigTransitoSchema = yup.object({
        tiempo_ejecucion: yup.number().required('El tiempo de ejecución es requerido').min(0, 'El tiempo de ejecución debe ser un número positivo'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newConfigTransitoSchema as any),
        defaultValues: {
            tiempo_ejecucion: 0,
            user_create: username,
            estado: true
        },
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors, isValid },
    } = form;

    const onConfirm = () => {
        if (!isValid) return;

        useCreateConfiguracionTransitoMutation.mutate(form.getValues(), {
            onSuccess: () => {
                // Invalidar la query de la lista de configuraciones para refrescar la tabla
                queryClient.invalidateQueries({ queryKey: ['configuracion-transito'] }); // Ajusta la key según tu hook
                toast.success("Configuracion Registrada Correctamente");
                onClose();
                reset();
                fetchData()
            },
            onError: (err) => {
                toast.error(err.message || 'Error al crear la configuracion de tránsito ');
            }
        });
    }

    const [bodega_origen, setBodegaOrigen] = useState('');

    ///* store, hook
    const {
        fetchAutocompleteUbicacion,
        fetchAutocompleteBodega
    } = useAutocompleteFetch();


    const ubicacionOrigenParams = useMemo(() => ({
        bodega: bodega_origen
    }), [bodega_origen])

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title="Agregar Configuracion de Tránsito"
                cancelTextBtn="Cerrar"
                onClose={onClose}
                confirmTextBtn="Guardar"
                onConfirm={handleSubmit(onConfirm)}
                minWidth="40%"
                contentNode={
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomTextFieldNumberComponente
                                    name="tiempo_ejecucion"
                                    label="Tiempo de Ejecución (horas)"
                                    control={control}
                                    error={errors.tiempo_ejecucion}
                                    helperText={errors.tiempo_ejecucion?.message}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <SampleCheckbox
                                    label="Estado"
                                    name="estado"
                                    control={form.control}
                                    defaultValue={!!form.getValues().estado || false}
                                    isState
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TabTextLabel
                                    text={"BODEGA / UBICACION DE CUSTODIA"}
                                    mt={0}
                                    pb={2}
                                    pl={0}
                                    pt={2}
                                />
                            </Grid>

                            <CustomAutocompleteFetchForm<BODEGAS, any, string>
                                control={control}
                                size={gridSizeMdLg6}
                                name="bodega_custodia"
                                //isAll
                                label={"Bodegas"}
                                fetchData={fetchAutocompleteBodega}
                                getOptionLabel={(opt) => opt.nombre || ''}
                                key={'autocomplete-bodega-custodia'}
                                getOptionKey={(o) => o.codigo!}
                                onChangeRawValue={(e) => {
                                    reset({
                                        ...form.getValues(),
                                        ubicacion_custodia: null,
                                    });
                                    if (e) {
                                        setBodegaOrigen(e.codigo)
                                    }
                                }}
                                loadOptionByValue={async (cod) => {
                                    const resp = await getBodegas({
                                        codigo: cod
                                    });
                                    return resp.data.data[0] ?? null
                                }}
                            />


                            <CustomAutocompleteFetchForm<Ubicaciones>
                                disabled={!bodega_origen}
                                control={control}
                                size={gridSizeMdLg6}
                                name="ubicacion_custodia"
                                label="Ubicación Custodia"
                                ///* fetch
                                fetchData={fetchAutocompleteUbicacion}
                                fetchParams={ubicacionOrigenParams}
                                loadOptionByValue={async (codigo) => {
                                    const res = await getUbicaciones({
                                        codigo: codigo as string
                                    });
                                    return res?.data.data[0] ?? null;
                                }}
                                getOptionLabel={(opt) => opt.nombre || ''}
                                key={'autocomplete-ubicacion-custodia'}
                                getOptionKey={(o) => o.codigo!}
                                onChangeValue={() => {
                                    // reset({ ...form.getValues(), ubicacion: e.codigo });
                                }}
                            />

                        </Grid>
                    </>
                }
            />
        </>
    )

}